import React from "react";
export const GalleryViewIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.25 1H2C1.44772 1 1 1.44772 1 2V5.25C1 5.80228 1.44772 6.25 2 6.25H5.25C5.80228 6.25 6.25 5.80228 6.25 5.25V2C6.25 1.44772 5.80228 1 5.25 1Z"
      stroke="#484964"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 1H10.75C10.1977 1 9.75 1.44772 9.75 2V5.25C9.75 5.80228 10.1977 6.25 10.75 6.25H14C14.5523 6.25 15 5.80228 15 5.25V2C15 1.44772 14.5523 1 14 1Z"
      stroke="#484964"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 9.75H10.75C10.1977 9.75 9.75 10.1977 9.75 10.75V14C9.75 14.5523 10.1977 15 10.75 15H14C14.5523 15 15 14.5523 15 14V10.75C15 10.1977 14.5523 9.75 14 9.75Z"
      stroke="#484964"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.25 9.75H2C1.44772 9.75 1 10.1977 1 10.75V14C1 14.5523 1.44772 15 2 15H5.25C5.80228 15 6.25 14.5523 6.25 14V10.75C6.25 10.1977 5.80228 9.75 5.25 9.75Z"
      stroke="#484964"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
